import { createAction } from "redux-actions";

export const SESSION_TOKEN_SET = "sessionTokenSet";

export default createAction<string>(SESSION_TOKEN_SET);
